import { render, staticRenderFns } from "./UserSummaryCard.vue?vue&type=template&id=155a54a1&"
import script from "./UserSummaryCard.vue?vue&type=script&lang=js&"
export * from "./UserSummaryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports